/**
 * @description 互动适配层入口
 * @author aprilcai
 */
import { loadScript } from '@iv/shared/src/load';

export const loadBridge = async (src: string, options?: any) => new Promise((resolve: Function, reject: Function) => {
  loadScript(src)
    .then(() => {
      resolve(new window.InteractVideoBridge(options));
    })
    .catch((error) => {
      reject(error);
    });
});

export const createBridge = async (type: string, options?: any) => {
  let bridge;
  if (window.InteractVideoBridge) {
    bridge = new window.InteractVideoBridge(options);
  } else {
    const src = `${JS_URL}adapter-bridge.${type}.global.min.js`;
    bridge = await loadBridge(src, options);
  }
  return bridge;
};
